import { render, staticRenderFns } from "./AiBanner.vue?vue&type=template&id=1f213baf&scoped=true&"
import script from "./AiBanner.vue?vue&type=script&lang=ts&"
export * from "./AiBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AiBanner.vue?vue&type=style&index=0&id=1f213baf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f213baf",
  null
  
)

export default component.exports